<div class="container py-4">

  <div *ngIf="error" class="text-center text-danger">{{ error }}</div>


  <div *ngIf="community" class="card shadow-sm border-0">
  
    <div *ngIf="community.banner_url" class="position-relative">
      <img
        [src]="community.banner_url"
        alt="Community Banner"
        class="w-100 rounded-top img-fluid"
        style="height: 220px; object-fit: cover;"
      />


      <div class="position-absolute" style="bottom: -50px; left: 20px;">
        <img
          *ngIf="community.logo_url"
          [src]="community.logo_url"
          alt="Community Logo"
          class="rounded-circle border border-white shadow"
          style="width: 100px; height: 100px; object-fit: cover;"
        />
      </div>
    </div>

  
    <div class="card-body pt-5 mt-3">
      <h2 class="card-title fw-bold text-dark">{{ community.community_name }}</h2>
      <p class="text-muted">{{ community.about_us_content }}</p>
    </div>
  </div>

 
  <div class="text-center mt-5 px-3 px-md-0">

    <h4 class="fw-bold mb-2 join-heading">Join Our Community</h4>


    <div
      *ngIf="totalUsers > 0"
      class="text-primary fw-semibold mb-3 user-count-highlight mx-auto"
    >
      Our community is growing — {{ totalUsers }} {{ totalUsers === 1 ? 'member' : 'members' }} strong and counting!
    </div>

    <p class="text-muted mb-3">
      Be a part of something meaningful. Connect, grow, and collaborate with like-minded individuals.
    </p>

    <button class="btn btn-success btn-lg px-4 py-2 btn-lite-blue" (click)="onJoinCommunity()">
      Join Now
    </button>
  </div>
</div>
